// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconArrowRightBold.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconArrowRightBold = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M8.67061 10.0065L11 7.88754L2.32939 2.96575e-08L-1.65529e-07 2.11901L8.67061 10.0065Z" />
    <path d="M11 8.11246L8.67061 5.99345L9.28405e-07 13.881L2.32939 16L11 8.11246Z" />
  </BaseIcon>
);

export default IconArrowRightBold;
